import React from 'react';

import classNames from 'classnames';
import { useIntl } from 'react-intl';
import InfoPage from '../InfoPage';
import { useConfiguration } from '../../../context/configurationContext';

import css from './AboutPage.module.css';

const AboutPage = props => {
  const { className } = props;

  const intl = useIntl();
  const config = useConfiguration();

  const classes = classNames(css.root, className);

  return (
    <InfoPage
      title={intl.formatMessage({ id: 'General.aboutUs' })}
      contentTitle={intl.formatMessage({ id: 'AboutPage.contentTitle' })}
      className={classes}
      currentPage="AboutPage"
    >
      <p className={css.firstP}>
        {intl.formatMessage(
          { id: 'AboutPage.contentDesc' },
          { marketplaceName: <b>{config.marketplaceName}</b> }
        )}
      </p>
      <p>{intl.formatMessage({ id: 'AboutPage.contentDesc2' })}</p>
    </InfoPage>
  );
};

export default AboutPage;
